import { render } from "./DelegateApprovals.vue?vue&type=template&id=662be7a7"
import script from "./DelegateApprovals.vue?vue&type=script&lang=js"
export * from "./DelegateApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__